import { TerminalError } from "@/utils/UTerminal";

import { TCommandArg } from "@/types";

export const typeArg = (props?: Partial<TCommandArg>): TCommandArg => ({
	name: "type",
	description: "The type of item",
	options: ["task", "project", "calendar"],
	required: true,
	check: (value) => {
		if (!["task", "project", "calendar"].includes(value)) {
			throw new TerminalError("invalidType", {
				type: value,
				command: props?.command ?? "",
			});
		}
		return true;
	},
	...props,
});
